require('magnific-popup/dist/jquery.magnific-popup')
import 'magnific-popup/dist/magnific-popup.css'